export default ({ columns }) => [
  {
    title: 'Заголовок', value: columns.fontSize1, paramName: 'fontSize1', parentName: 'columns',
  },
  {
    title: 'Текст в ячейке', value: columns.fontSize2, paramName: 'fontSize2', parentName: 'columns',
  },
];
